/**
 * Easing for the water — by elapsed time, never by frame count.
 *
 * The engine used to move the level a fixed 11% of the way per frame, so the
 * water rose twice as fast on a 120Hz phone as on a 60Hz one and a dropped
 * frame stalled it. `easeToward` closes a share of the gap set by how much
 * *time* passed: half of it per `halfLifeMs`. Two 8ms steps land exactly where
 * one 16ms step does.
 *
 * Exponential, so it never overshoots — the surface approaches its mark and
 * stops, which is the honest motion for a number that is not going to change
 * again until the next expense.
 */

/** Below this gap a value is "there"; the engine snaps and stops drawing. */
export const SETTLE_EPSILON = 0.0015;

/** Move `current` toward `target` by the share `dtMs` earns at this half-life. */
export function easeToward(current: number, target: number, dtMs: number, halfLifeMs: number): number {
  if (dtMs <= 0) return current;
  if (!Number.isFinite(dtMs)) return target;
  const remaining = 2 ** (-dtMs / halfLifeMs);
  return target + (current - target) * remaining;
}

export function isSettled(current: number, target: number, epsilon = SETTLE_EPSILON): boolean {
  return Math.abs(target - current) < epsilon;
}
